module.exports = __webpack_public_path__ + "static/media/flexibility_scalability.1759cdef.svg";